import { render } from "./ProductDetail.vue?vue&type=template&id=5ac1068d&bindings={\"goBack\":\"setup\",\"goTo\":\"setup\",\"handleAddCart\":\"setup\",\"goToCart\":\"setup\",\"count\":\"setup\"}"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script